import { cn } from '../lib/utils';

/** AADPA brand mark — the official app icon. Size via className (e.g. "size-9"). */
export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      src="/brand/aadpa-icon.png"
      alt="AADPA"
      className={cn('rounded-lg object-contain', className)}
    />
  );
}
